import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  loading_container: {
    width: '100%',
    height: '70vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));
